import { LogLevel } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || '',
    authority: process.env.REACT_APP_AUTH_ISSUER || '',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage', // ✅ more stable for mobile
    storeAuthStateInCookie: true, // ✅ helps Safari/iOS
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) {
          console.error(`[MSAL ERROR] ${message}`);
        }
      },
      logLevel: LogLevel.Error,
      piiLoggingEnabled: false,
    },
  },
};

// Access-token request for the LGM API. MSAL must mint a token whose audience
// (`aud`) is our own API (api://<clientId>), NOT Microsoft Graph. A Graph/OIDC-
// only token (e.g. scopes ['User.Read','openid',...]) has the wrong `aud`;
// additionally Microsoft Graph access tokens carry a nonce in the JWT header
// and cannot be signature-validated by third parties, which is why the API
// rejects them with 401 "invalid signature" rather than an audience error.
// The SPA and API share one app registration, so the API scope is
// api://<clientId>/acc (exposed scope name "acc"). REACT_APP_API_SCOPE can
// override the full scope string if needed.
const clientId = process.env.REACT_APP_AZURE_CLIENT_ID || '';
const apiScope =
  process.env.REACT_APP_API_SCOPE || (clientId ? `api://${clientId}/acc` : '');

export const apiRequest = {
  scopes: apiScope ? [apiScope] : [],
};

// Include the API scope at login so consent is granted up front and later
// silent token acquisition for the API succeeds without an extra redirect.
export const loginRequest = {
  scopes: ['openid', 'profile', 'email', ...apiRequest.scopes],
};
